import AsCsConversionResult from './AsCsConversionResult';
import ManualConversionResult from './ManualConversionResult';

import type { IFileUploadStatus } from '../../../../../../../../shared/apis/ai-agent/file/types';
import type { TrackingType } from '../../types';

interface IPropsConversionResult {
  trackingType: TrackingType;
  uploadHistory?: Pick<IFileUploadStatus, 'fileName' | 'failYn' | 'failReason' | 'status'>;
}

export default function ConversionResult(props: IPropsConversionResult) {
  const { trackingType, uploadHistory } = props;

  if (!uploadHistory) return null;

  if (trackingType === 'manual') return <ManualConversionResult uploadHistory={uploadHistory} />;

  return <AsCsConversionResult uploadHistory={uploadHistory} />;
}
